import { render } from "./form-heading.vue?vue&type=template&id=7bfc8431"
import script from "./form-heading.vue?vue&type=script&lang=js"
export * from "./form-heading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__